// Descendants that own their own click / keyboard behavior. A row-level
// activation handler (click-to-navigate, Enter/Space) must NOT treat an event
// originating from one of these as a row activation.
//
// `[role="menuitem"]` covers Radix dropdown items: they portal outside the
// `<tr>` in the real DOM but still bubble their synthetic events to the row's
// React handlers, so without this the row would navigate when a menu item is
// picked.
const INTERACTIVE_DESCENDANT_SELECTOR = 'button, a, input, [role="checkbox"], [role="menuitem"]'

/**
 * True when an event originated from an interactive descendant that handles its
 * own activation, so the row's own click/keydown handler should stand down.
 *
 * Uses `Element` (not `HTMLElement`) so a click landing on an SVG icon inside a
 * button is still recognized as interactive.
 */
export const isInteractiveElementClick = (event: React.SyntheticEvent): boolean =>
  event.target instanceof Element && event.target.closest(INTERACTIVE_DESCENDANT_SELECTOR) !== null
